import { gql } from '@apollo/client';

import { useQuery } from 'shared/hooks';

/*
  "preferredDateFormat": "mdy", -> MM/DD/YYYY
  "preferredDateFormat": "dmy", -> DD/MM/YYYY
  "preferredDateFormat": "ymd", -> YYYY-MM-DD
  "preferredDateFormat": "auto" -> "Use the browser's default date format"
*/
export const USER_DATE_PREFERENCES_QUERY = gql`
  query UserDatePreferenceOperation {
    currentUser {
      preferredDateFormat
      showTimezoneOffset
    }
  }
`;

export const useDateTimeFormat = () => {
  const dateFormat = useDateFormat();
  const timeFormat = useTimeFormat();
  return `${dateFormat} ${timeFormat}`;
};

export const useDateFormat = () => {
  const { data } = useQuery(USER_DATE_PREFERENCES_QUERY);

  switch (data?.currentUser?.preferredDateFormat) {
    case 'mdy':
      return 'MM/DD/YYYY';
    case 'dmy':
      return 'DD/MM/YYYY';
    case 'ymd':
      return 'YYYY-MM-DD';
    default:
      return 'L';
  }
};

export const useTimeFormat = () => {
  const { data } = useQuery(USER_DATE_PREFERENCES_QUERY);
  return `LTS ${data?.currentUser.showTimezoneOffset ? 'ZZ' : ''}`;
};
